<fuse-widget class="widget p-0 h-100-p" fxLayout="column">
  <!-- Front -->
  <div
    class="fuse-widget-front mat-white-bg mat-elevation-z2"
    fxLayout="column"
    fxLayoutAlign="stretch stretch"
  >
    <div
      class="px-16 py-8 border-bottom widget-header title-bar mat-accent-bg"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <div class="mat-accent-bg" fxLayout="row" fxLayoutAlign="start center">
        <div id="txtWidgetTitle" class="h3 title pr-4">{{ widgetTitle }}</div>
        <div *ngIf="secondaryTitle" fxLayout="row" fxLayoutAlign="start center">
          <div class="h3 pr-4">-</div>
          <div
            id="txtWidgetSubtitle"
            class="h3 secondary"
            *ngIf="secondaryTitle"
          >
            {{ secondaryWidgetTitle }}
          </div>
        </div>
      </div>
      <app-translation-controls
        *ngIf="showTranslationControls"
        [language]="language"
        [showTranslation]="showTranslation"
        (onLanguageChange)="onLanguageChange($event)"
        (onShowTranslationChange)="onShowTranslationChange($event)"
      >
      </app-translation-controls>
    </div>

    <div style="overflow: auto">
      <div class="p-12" fxLayout="column">
        <div fxLayout="row">
          <div style="width: 350px">
            <table style="width: 100%; margin-top: -32px" role="presentation">
              <tr style="opacity: 0">
                <th class="label">FieldName</th>
                <th class="fieldValue">Value</th>
              </tr>
              <tr>
                <td class="field-label">Source:</td>
                <td class="fieldValue">{{ referral?.referralSource?.name }}</td>
              </tr>
              <tr>
                <td class="field-label">Summary:</td>
                <td class="fieldValue">{{ referral?.summary }}</td>
              </tr>
              <tr>
                <td class="field-label">Referrer:</td>
                <td class="fieldValue">{{ referral?.referrerName }}</td>
              </tr>
              <tr>
                <td class="field-label">Referrer Telephone:</td>
                <td class="fieldValue">{{ referral?.referrerTelephone }}</td>
              </tr>
              <tr *ngIf="!reportDetails?.anonymous">
                <td class="field-label">Referrer Email:</td>
                <td class="fieldValue">
                  {{ referral?.referrerEmail || reportDetails?.optionalEmail }}
                </td>
              </tr>
              <tr
                *ngIf="
                  referral?.referralSource &&
                  referral?.referralSource.name !== 'File a Concern Website'
                "
              >
                <td class="field-label">Category:</td>
                <td class="fieldValue">                  
                  <span translate [language]="language" [showTranslation]="showTranslation" [innerHtml]="categoryDescription"></span>
                </td>
              </tr>
            </table>
          </div>
          <div style="width: 350px">
            <table style="width: 100%; margin-top: -32px" role="presentation">
              <tr style="opacity: 0">
                <th class="label">FieldName</th>
                <th class="fieldValue">Value</th>
              </tr>
              <tr>
                <td class="field-label">Referral Date:</td>
                <td class="fieldValue">
                  {{ referral?.referralDate | date : 'dd/MMM/yyyy' }}
                </td>
              </tr>
              <tr *ngIf="!onlineReportingReferral">
                <td class="field-label">Manager:</td>
                <td class="fieldValue">{{ referral?.managerName }}</td>
              </tr>
              <tr *ngIf="!onlineReportingReferral">
                <td class="field-label">Manager Telephone:</td>
                <td class="fieldValue">{{ referral?.managerTelephone }}</td>
              </tr>
              <tr *ngIf="!onlineReportingReferral">
                <td class="field-label">Manager Email:</td>
                <td class="fieldValue">{{ referral?.managerEmail }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div class="formWidgetContainer" style="margin-top: -10px">
        <div
          *ngIf="
            referral?.referralSource &&
            referral?.referralSource.name === 'File a Concern Website' &&
            referral?.reportJson
          "
        >
          <fac-report-widget
            [jsonData]="reportDetails"
            [language]="language"
            [showTranslation]="showTranslation"
          ></fac-report-widget>
        </div>
        <div *ngIf="!onlineReportingReferral && referral?.reportJson">
          <referral-data-widget
            [jsonData]="reportDetails"
          ></referral-data-widget>
        </div>
      </div>
    </div>
  </div>
</fuse-widget>
